// extracted by mini-css-extract-plugin
export var container = "_dh-0";
export var popoverContent = "_dh-1";
export var tosLink = "_dh-2";